import { render, staticRenderFns } from "./SalesInvoicesList.vue?vue&type=template&id=32f594c6&"
import script from "./SalesInvoicesList.vue?vue&type=script&lang=js&"
export * from "./SalesInvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./SalesInvoicesList.vue?vue&type=style&index=0&id=32f594c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports